import React from "react";
import Seo from "../components/Generic/Seo"; // Import Seo component
import RolesList from "../components/RolesList";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const Directory = () => {
  const seoData = {
    title: "Directory | Wise Community",
    description:
      "Explore the Wise Community Directory to find member roles, contact information, and connect with professionals in the semiconductor ecosystem.",
    keywords:
      "Directory, Wise Community, Roles, Contact, Members, Semiconductor Ecosystem",
    pathSlug: "directory",
  };

  return (
    <>
      <Seo data={seoData} />

       <GoogleAnalytics
        page={seoData.pathSlug}
        title={ seoData.title}
      />

      <div className="p-5">
        <h1>Directory</h1>
        <p>Find roles and contact information of community members below.</p>

        <RolesList />
      </div>
    </>
  );
};

export default Directory;
